import { render, staticRenderFns } from "./FormCategoryTreeSelect.vue?vue&type=template&id=74e70170"
import script from "./FormCategoryTreeSelect.vue?vue&type=script&lang=js"
export * from "./FormCategoryTreeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports